import React from 'react';
import { Transition } from '@headlessui/react';

import { Portal } from 'ui';

type Props = {
  open: boolean;
  onOverlayClick?: () => void;
  children: React.ReactNode;
  inverted?: boolean;
  transparent?: boolean;
  elevated?: boolean;
};

function Overlay({ open, onOverlayClick, children, inverted = false, transparent = false, elevated = false }: Props) {
  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
    if (onOverlayClick) onOverlayClick();
  };

  let bgColor = 'bg-gray-500';
  if (transparent) {
    bgColor = 'transparent';
  } else if (inverted) {
    bgColor = 'bg-gray-100';
  }

  return (
    <Portal>
      <Transition
        show={open}
        className={elevated ? 'relative z-50' : undefined}
        enter="ease-out duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="ease-in duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="fixed inset-0 z-40 overflow-y-auto">
          <div className="flex min-h-screen items-end justify-center px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            {/* Background overlay, show/hide based on modal state. */}
            <div className="fixed inset-0 transition-opacity" aria-hidden="true" onClick={handleOverlayClick}>
              <div className={`absolute inset-0 opacity-75 ${bgColor}`} />
            </div>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span className="hidden sm:inline-block sm:h-screen sm:align-middle" aria-hidden="true">
              &#8203;
            </span>

            <div className="contents">{children}</div>
          </div>
        </div>
      </Transition>
    </Portal>
  );
}

export default Overlay;
